import { useEffect } from "react"


const QRcode = ({ open }) => {
    useEffect(() => {
        document.title = 'QR Code'
    }, [])

    let url = window.location.href
    let imgqr = url.split('#')[1]

    return (
        <div className='container-fluid bg-dark pt-5' style={{ height : '100vh' }}>
                <div className='row'>
                    <div className='col-sm-4 mx-auto my-5'>
                    <img src={imgqr} alt ='...' />
                    </div>
                </div>
            </div>
    )
}
export default QRcode